import { type UseQueryResult, useQuery } from 'react-query';
import { TermsAndConditionsService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetTermAndConditionPageList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const TermAndConditionPageList = useQuery(
    ['getTermAndConditionPageList'],
    async () => {
      return await handleRequest(
        TermsAndConditionsService.getApiCustomerApiAppTermsAndConditionsPages()
      );
    },
    {
      select: (data) => {
        return data?.data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return TermAndConditionPageList;
};

export default useGetTermAndConditionPageList;
